import actionCancer from '@propertypal/shared/src/resources/logos/action-cancer.png';
import PNLogo from '@propertypal/shared/src/resources/logos/property-news-logo.svg?url';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { displayConsentUi } from '../../services/ads/cmp';
import { SiteMapData } from './Footer';
import { BottomRow, BoxWrapper, Container, Content, LinkGrid } from './Footer.pn.style';
import SiteMapFooter from './site-map-footer/SiteMapFooter';
import SocialLinks from './social-links/SocialLinks';

interface Props {
  siteMapData: SiteMapData[] | null;
}

const Footer: FunctionComponent<Props> = (props) => {
  return (
    <>
      {!!props.siteMapData?.length && <SiteMapFooter siteMapData={props.siteMapData} />}

      <Container>
        <Content>
          <BoxWrapper>
            <SocialLinks />

            <Link href="https://agents.propertynews.com">Estate Agent Area</Link>
          </BoxWrapper>

          <LinkGrid>
            <Link href="/property-for-sale">For Sale</Link>
            <Link href="/property-to-rent">To Rent</Link>
            <Link href="/new-homes/northern-ireland">New Homes</Link>
            <Link href="/commercial-property-for-sale">Commercial</Link>
            <Link href="/land-for-sale">Land &amp; Sites</Link>
            <Link href="/promote/premier">Promote Your Property</Link>
          </LinkGrid>

          <LinkGrid>
            <Link href="/news">News</Link>
            <Link href="/contact">Contact Us</Link>
            <Link href="/faq">FAQ</Link>
            <Link href="/privacy">Privacy Policy</Link>
            <Link href="/cookie-policy">Cookie Policy</Link>
            <Link href="/terms">Terms &amp; Conditions</Link>
            <Link href="/site-map">Propertynews Site Map</Link>
            <button onClick={displayConsentUi} type="button">
              Consent Management
            </button>
          </LinkGrid>

          <BottomRow>
            <div>
              <img src={PNLogo.src} alt="PropertyNews" />
              <p>Copyright © Propertynews.com 2025</p>
            </div>

            <div>
              <p>
                <b>PROUD TO PARTNER WITH</b>
              </p>
              <a
                href="https://actioncancer.org/fundraising/support-action-cancer-through-propertynews/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={actionCancer.src} alt="Action Cancer" style={{ height: 50 }} />
              </a>
            </div>
          </BottomRow>
        </Content>
      </Container>
    </>
  );
};

export default Footer;
